import { MuiStylesType } from 'model/muiStyles.model';

export const muiStyles: MuiStylesType = {
  dotDivider: {
    width: '5px',
    height: '5px',
    borderRadius: '100%',
    flexShrink: 0,
    backgroundColor: 'inherit',
  },
};
